import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './PublicNav.css';
import LoginModal from './auth/LoginModal';

export default function PublicNav({ onLogin, overlay = false }) {
  const location = useLocation();
  const [menuOpen, setMenuOpen]       = useState(false);
  const [showLogin, setShowLogin]     = useState(false);

  const isActive = (path) => location.pathname === path;

  const openLogin = () => { setMenuOpen(false); setShowLogin(true); };

  return (
    <>
      <nav className={`pub-nav${overlay ? ' pub-nav--overlay' : ''}`}>
        <div className="pub-nav-inner">
          <Link to="/" className="pub-nav-logo" onClick={() => setMenuOpen(false)}>
            <img src="/logo.webp" alt="TDA" />
            <span>TDA Tournament Center</span>
          </Link>

          {/* Desktop Links */}
          <div className="pub-nav-links">
            <Link to="/" className={`pub-nav-link${isActive('/') ? ' pub-nav-link--active' : ''}`}>
              Home
            </Link>
            <Link to="/ranking" className={`pub-nav-link${isActive('/ranking') ? ' pub-nav-link--active' : ''}`}>
              Ranking
            </Link>
            <Link to="/fuer-veranstalter" className={`pub-nav-link pub-nav-link--highlight${isActive('/fuer-veranstalter') ? ' pub-nav-link--active' : ''}`}>
              Für Veranstalter
            </Link>
            <Link to="/apps" className={`pub-nav-link${isActive('/apps') ? ' pub-nav-link--active' : ''}`}>
              Apps
            </Link>
            <a href="https://tda-intl.org" className="pub-nav-link">TDA International</a>
            <a href="https://tda-intl.org/kontakt" className="pub-nav-link">Kontakt</a>
            <Link to="/registrieren" className="pub-nav-link pub-nav-link--reg">Registrieren</Link>
            <button className="pub-nav-btn" onClick={openLogin}>Login</button>
          </div>

          {/* Mobile Hamburger */}
          <button
            className={`pub-nav-hamburger${menuOpen ? ' pub-nav-hamburger--open' : ''}`}
            onClick={() => setMenuOpen(o => !o)}
            aria-label="Menü"
          >
            <span /><span /><span />
          </button>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="pub-nav-mobile" onClick={() => setMenuOpen(false)}>
            <Link to="/" className="pub-nav-mobile-link">Home</Link>
            <Link to="/ranking" className="pub-nav-mobile-link">Ranking</Link>
            <Link to="/fuer-veranstalter" className="pub-nav-mobile-link pub-nav-mobile-link--highlight">Für Veranstalter</Link>
            <Link to="/apps" className="pub-nav-mobile-link">Apps</Link>
            <a href="https://tda-intl.org" className="pub-nav-mobile-link">TDA International</a>
            <a href="https://tda-intl.org/kontakt" className="pub-nav-mobile-link">Kontakt</a>
            <Link to="/registrieren" className="pub-nav-mobile-link pub-nav-mobile-link--highlight">Registrieren</Link>
            <button className="pub-nav-mobile-btn" onClick={openLogin}>Login</button>
          </div>
        )}
      </nav>

      <LoginModal
        isOpen={showLogin}
        onClose={() => setShowLogin(false)}
        onLogin={onLogin}
      />
    </>
  );
}
